import { OcapiHeader } from '../types/ocapi-header';
export const getCaptchaRequestConfig = (captchaResponse) => {
    if (!captchaResponse)
        return undefined;
    return { headers: new Headers({ [OcapiHeader.CaptchaResponse]: captchaResponse }) };
};
//# sourceMappingURL=get-captcha-request-config.js.map